import React, { useMemo } from "react";
import ChildrensBookManuscriptEditor from "./ChildrensBookManuscriptEditor";
import ChildrensBookManuscriptReadOnly from "./ChildrensBookManuscriptReadOnly";

function clean(value) {
  return value == null ? "" : String(value).trim();
}

export function NovelStorySceneRichEditor({
  id = "novel-story-scene",
  title = "",
  text = "",
  manuscriptContent = null,
  disabled = false,
  lang = "en",
  saveActionLabel = "",
  onChange,
}) {
  const isFR = String(lang || "en").toLowerCase().startsWith("fr");

  const entry = useMemo(
    () => ({
      id: clean(id) || "novel-story-scene",
      manuscriptText: String(text || ""),
      ...(manuscriptContent &&
      typeof manuscriptContent === "object" &&
      !Array.isArray(manuscriptContent)
        ? { manuscriptContent }
        : {}),
    }),
    [id, manuscriptContent, text]
  );

  return (
    <section
      data-novel-story-scene-rich-editor="true"
      aria-label={
        isFR ? "Éditeur riche de scène" : "Rich Scene editor"
      }
      style={{
        border: "1px solid rgba(5,150,105,0.22)",
        borderRadius: 16,
        padding: 14,
        background: "#ffffff",
      }}
    >
      <style>{`
        [data-novel-story-scene-rich-editor="true"]
        [data-manuscript-editor-surface="true"] {
          min-height: 380px !important;
          height: auto !important;
          max-height: none !important;
          overflow: visible !important;
          resize: none !important;
        }

        @media (max-width: 700px) {
          [data-novel-story-scene-rich-editor="true"]
          [data-manuscript-editor-surface="true"] {
            min-height: 320px !important;
            height: auto !important;
          }
        }
      `}</style>

      {clean(title) ? (
        <div
          className="ns-card-meta"
          style={{
            marginBottom: 10,
            fontWeight: 800,
            color: "#475569",
          }}
        >
          {clean(title)}
        </div>
      ) : null}

      <ChildrensBookManuscriptEditor
        lang={isFR ? "fr" : "en"}
        entry={entry}
        disabled={disabled}
        saveActionLabel={
          clean(saveActionLabel) ||
          (isFR ? "Enregistrer la scène" : "Save Scene")
        }
        enableHighlight={true}
        enableWholeDocumentJustify={true}
        embeddedFlow={true}
        compactContinuousParagraphSpacing={true}
        boundedSurface={false}
        onChange={(next) => {
          onChange?.({
            manuscriptContent: next?.manuscriptContent || null,
            text: String(next?.manuscriptText || ""),
            selectionHandoff: next?.selectionHandoff || null,
            editIntent: next?.editIntent || null,
          });
        }}
      />
    </section>
  );
}

export function NovelStorySceneReadOnly({
  scene = null,
  text = "",
  manuscriptContent = null,
  lang = "en",
}) {
  const resolvedText =
    scene?.text !== undefined ? scene.text : text;
  const resolvedContent =
    scene?.manuscriptContent !== undefined
      ? scene.manuscriptContent
      : manuscriptContent;

  if (
    resolvedContent &&
    typeof resolvedContent === "object" &&
    !Array.isArray(resolvedContent)
  ) {
    return (
      <ChildrensBookManuscriptReadOnly
        content={resolvedContent}
        fallbackText={String(resolvedText || "")}
        lang={lang}
      />
    );
  }

  return String(resolvedText || "");
}
